import InstructionSelect from './InstructionSelect';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ReduxState, useAppDispatch } from '../../../../../../../../store';
import { InstructionType } from '../../../redistributionImportTypes';
import { setImportInstructionSpecification } from '../../../../../../../Calculations/calculationsSlice';

const InstructionSelectController: React.FC = () => {
  const dispatch = useAppDispatch();

  const instructionType = useSelector(
    (state: ReduxState) => state.calculations.redistributionImport.instructionSpecification,
  );

  const instructionTypeChanged = useCallback(
    (newValue: InstructionType) => {
      dispatch(setImportInstructionSpecification(newValue));
    },
    [dispatch],
  );

  return <InstructionSelect value={instructionType} onChange={instructionTypeChanged} />;
};

export default InstructionSelectController;
